module.exports = __webpack_public_path__ + "static/media/observadorLogo.f3437d09.webp";